import { render } from "./LeadPrice.vue?vue&type=template&id=f91381e2"
import script from "./LeadPrice.vue?vue&type=script&lang=js"
export * from "./LeadPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__